module.exports = require("@mui/icons-material/TextFormat");